export default __webpack_public_path__ + "static/media/back-3.17a18e20.png";